const MONTH_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/;
const SHANGHAI_TIME_ZONE = "Asia/Shanghai";

const formatMonth = ({ year, month }) => `${year}-${String(month).padStart(2, "0")}`;

const getShanghaiYearMonth = (now = new Date()) => {
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: SHANGHAI_TIME_ZONE,
        year: "numeric",
        month: "2-digit",
    }).formatToParts(now);
    const values = parts.reduce((result, part) => {
        if (part.type === "year" || part.type === "month") result[part.type] = Number(part.value);
        return result;
    }, {});

    return {
        year: values.year,
        month: values.month,
    };
};

const getCampusMonthBounds = (now) => {
    const { year, month } = getShanghaiYearMonth(now);

    return {
        enrollmentMax: formatMonth({ year, month: 12 }),
        expectedGraduationMin: formatMonth({ year, month }),
        expectedGraduationMax: formatMonth({ year: year + 10, month }),
    };
};

const getExpectedGraduationMonthError = (value, bounds = getCampusMonthBounds()) => {
    if (!MONTH_PATTERN.test(value)) return "请选择正确的预计毕业年月";
    if (value < bounds.expectedGraduationMin) return "预计毕业年月不能早于当前月份";
    if (value > bounds.expectedGraduationMax) return "预计毕业年月不能晚于当前年月后10年";
    return "";
};

const getExpectedGraduationMinimum = (enrollmentMonth, bounds = getCampusMonthBounds()) => (
    MONTH_PATTERN.test(enrollmentMonth) && enrollmentMonth > bounds.expectedGraduationMin
        ? enrollmentMonth
        : bounds.expectedGraduationMin
);

const getPickerMonth = (value) => {
    if (!(value instanceof Date)) return "";
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}`;
};

const isMonthOutsideRange = (value, min, max) => {
    const month = getPickerMonth(value);
    return !month || month < min || month > max;
};

module.exports = {
    getCampusMonthBounds,
    getExpectedGraduationMinimum,
    getExpectedGraduationMonthError,
    isMonthOutsideRange,
};
